<template>
  <div id="author-submitted-manuscripts">
    <div class="ipub-h1 mar-b-20 line-h-40 relative">
      Submitted Manuscripts
      <div class="ipub-p1 right-option"
           v-if="user.completed">
        <ipub-button type="primary"
                     @click="submit">
          New Submission
        </ipub-button>
      </div>
    </div>
    <ipub-row :gutter="[12, 16]">
      <ipub-col :span="12">
        <site-search-group v-model.trim="params.keyword"
                           placeholder="Search by manuscript no., title"
                           @search="getList()"
                           @clear="handleClear" />
      </ipub-col>
    </ipub-row>

    <div class="ipub-p1 mar-b-30 list-tab-content">
      <a v-for="(val, key) in count"
         @click="changeStatus(key)"
         style="margin-right:80px"
         :key="key"
         :class="['ipub-list-tab--status',params.status===key?'active':'']">{{STATUS[key]}} ({{val||0}})</a>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns[params.status]"
                  :empty="{icon:'iconSI_article'}"
                  :emptyText="emptyText[params.status]"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:img="{record}">
          <img class="ipub-table-slot-img"
               :src="`${domain}/${record.journal.cover}`"
               alt="">
        </template>
        <template v-slot:time="{record}">
          <div class="ipub-p2">
            <div v-if="record.reviseDueTime">
              <template v-if="!['COMPLETED'].includes(record.status)">
                <div class="ipub-p2 fw-bd"
                     :class="$moment(record.reviseDueTime).diff($moment(), 'days')<4?'warning-color':''"
                     v-if="$moment(record.reviseDueTime).diff($moment(), 'days')>0">{{$moment(record.reviseDueTime).diff($moment(), 'days')}} Days left</div>
                <div class="ipub-p2 fw-bd"
                     :class="'key-color'"
                     v-else>{{$moment(record.reviseDueTime).diff($moment(), 'days')}} Days Over Due</div>
              </template>
              <div>{{$moment(record.reviseDueTime).format('DD / MM / YYYY')}}</div>
            </div>
            <template v-else>- -</template>
          </div>

        </template>
        <template v-slot:date="{record}">
          <div v-if="status1[record.status]!='Timeout'">
            <p class="ipub-p2 fw-bd">{{status1[record.status]}}</p>
            <span>{{ (record.statusTime)?$moment(record.statusTime).format('DD / MM / YYYY'): '- -' }}</span>
          </div>
          <span v-else>Timeout</span>
        </template>
        <template v-slot:step="{text}"
                  class="ipub-p2">
          Step {{text}} of 5 Completed
        </template>
        <template v-slot:special="{text}">
          <ipub-tooltip v-if="text"
                        style="width:100%"
                        placement="bottomLeft"
                        class="ipub-p2"
                        omis="omission"
                        :label="`${text.titleText}`" />
          <template v-else>--</template>
        </template>
        <!--
          重新提交  Pending Resubmission
          稿件详情 v-else Pending review、Under review、Pending decision
          修订  Pending minor revisions、Pending major revisions
          申请延时 Timeout
          编辑、删除 Uncommitted
          查看决策 Timeout、Paper accepted、Rejected、Withdrawn
         -->
        <template v-slot:actions="{ record }">
          <div v-show="false">{{record.status}}</div>
          <!-- {{['PENDING_MINOR_REVISIONS','PENDING_MAJOR_REVISIONS'].includes(record.status)}} -->
          <!-- 编辑删除 -->
          <template v-if="['UNCOMMITTED'].includes(record.status)">
            <ipub-tooltip class="border-right">
              <div slot="title">Edit</div>
              <ipub-icon type="iconEdit"
                         @click="edit(record)" />
            </ipub-tooltip>
            <ipub-tooltip>
              <div slot="title">Delete</div>
              <ipub-icon type="iconDelete"
                         @click="del(record)" />
            </ipub-tooltip>
          </template>
          <!-- 申请延时 -->
          <!-- <template v-if="['TIMEOUT'].includes(record.status)">
            <ipub-tooltip class="border-right">
              <div slot="title">To apply for delay</div>
              <ipub-icon type="iconTime"
                         @click="sendEmail(record)" />
            </ipub-tooltip>
          </template> -->
          <!-- 修订 -->
          <template v-if="['PENDING_MINOR_REVISIONS','PENDING_MAJOR_REVISIONS'].includes(record.status)">
            <ipub-tooltip class="border-right">
              <div slot="title">Revision</div>
              <ipub-icon type="iconreviewer"
                         @click="revision(record)" />
            </ipub-tooltip>
          </template>
          <!-- 重新提交 -->
          <template v-if="['PENDING_RESUBMISSION'].includes(record.status)">
            <ipub-tooltip class="border-right">
              <div slot="title">To resubmit</div>
              <ipub-icon type="iconSubmitYourPaper"
                         @click="recommit(record)" />
            </ipub-tooltip>
          </template>
          <!-- 查看决策 -->
          <template v-if="['PAPER_ACCEPTED','REJECTED','WITHDRAWN','ONLINE'].includes(record.status)">
            <ipub-tooltip class="border-right">
              <div slot="title">View the decision</div>
              <ipub-icon type="iconViewDetails"
                         @click="decision(record)" />
            </ipub-tooltip>
          </template>
          <!-- 稿件详情 -->
          <!-- <template v-else> -->
          <!-- Submitted 、Pending review、Pending decision、Revised version review、Paper accepted、Rejected、Withdrawn -->
          <template v-if="['SUBMITTED','PENDING_REVIEW','PENDING_APC_CONFIRM','PENDING_PRE_CHECK','PRE_CHECK_DONE','PENDING_FIRST_DECISION','FIRST_DECISION_DONE','PENDING_FINAL_DECISION','FINAL_DECISION_DONE','PENDING_DECISION','REVISED_VERSION_REVIEW','UNDER_REVIEW','RESUBMISSION','REVISED_REVIEW'].includes(record.status)">
            <ipub-tooltip>
              <div slot="title">Details</div>
              <ipub-icon type="iconViewDetails"
                         @click="detail(record)" />
            </ipub-tooltip>
          </template>
        </template>
      </ipub-table>
    </div>
    <Detail :isVisable="isVisable"
            :inputData="inputData"
            @cancel="cancel" />
    <!-- 编辑决策Edit -->
    <SendEmail :isVisable="showSendEmail"
               :inputData="inputData"
               event="AUTHOR_APPLY_FOR_DELAYING_REVISION"
               @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
